import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import NoteDeFraisForm from "@/features/rh/notes-de-frais/components/NoteDeFraisForm";

export const Route = createFileRoute("/_app/rh/notes-de-frais/create")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view"),
  staticData: {
    title: "Nouvelle Note de Frais",
    permission: PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view",
    module: "rh",
    showInTab: false,
  },
  component: NoteDeFraisForm,
});
